import { InventoryTransferStatus } from './enums';

export class StockTransferListItem {
    DocEntry: number;
    RequestNo: number;
    DocDate: Date;
    FromWarehouse: string;
    ToWarehouse: string;
    ItemsCount: number;
    Status: InventoryTransferStatus;
    StatusLabel?: string;
}
